import {Outlet} from 'react-router-dom';
import {Layout as MarketingLayout} from 'src/layouts/marketing';
import Error401Page from 'src/pages/401';
import Error404Page from 'src/pages/404';
import Error500Page from 'src/pages/500';
import {customChartRoute, dashboardBaseRoute, dashboardRoutes} from './dashboard';
import Login from "../pages/Login";
import ResetPassword from "../pages/ResetPassword";
import Register from "../pages/Register";
import AuthChange from "../pages/AuthChange";
import {Navigate} from "react-router";
import {Layout as AuthModernLayout} from "../layouts/auth/modern-layout";
import CustomChart from "../pages/CustomChart";

export const loginRoute = 'login';
export const displayEvents = 'connect';
export const registerRoute = 'register';
export const resetPasswordRoute = 'resetPassword';
export const emailVerificationRoute = 'emailVerification';
export const authChangeRoute = 'authChange';


export const not_found_path = '404';
export const routes = [
  {
    element: (
      <MarketingLayout>
        <Outlet />
      </MarketingLayout>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={"/" + dashboardBaseRoute}/>
      },
      {
        path: loginRoute,
        element:
          <AuthModernLayout>
            <Login />
          </AuthModernLayout>
      },
      { path: customChartRoute,
        element:
            <CustomChart/>
      },
      {
        path: resetPasswordRoute,
        element:
          <AuthModernLayout>
            <ResetPassword />
          </AuthModernLayout>
      },
      {
        path: registerRoute,
        element:
          <AuthModernLayout>
            <Register />
          </AuthModernLayout>
      },
      {
        path: authChangeRoute,
        element:
          <AuthModernLayout>
            <AuthChange />
          </AuthModernLayout>
      },

    ]
  },
  ...dashboardRoutes,
  {
    path: '401',
    element: <Error401Page />
  },
  {
    path: not_found_path,
    element: <Error404Page />
  },
  {
    path: '500',
    element: <Error500Page />
  },
  {
    path: '*',
    element: <Error404Page />
  }
];
